import AuthService from '../../utilities/services/auth.service'
import { InsightsDashboardWrapper } from '../../components'

export default function InsightsDashboardPage() {
  const organization = AuthService.getOrg()[0]
  return <InsightsDashboardWrapper organization={organization} />
}
